/**
 * 퀘스트 로그 (Q).
 */

import Phaser from 'phaser';
import { QUESTS } from '../data/quests';
import { EV } from '../game/events';
import { questPhase, questProgress } from '../systems/questLogic';
import type { PlayerState } from '../systems/PlayerState';
import { COLOR, TEXT_COLOR, UI_FONT, UI_MONO } from './theme';

const WIDTH = 420;
const HEIGHT = 360;
const PAD = 14;

export class QuestLogWindow {
  private readonly container: Phaser.GameObjects.Container;
  private readonly body: Phaser.GameObjects.Text;

  constructor(
    scene: Phaser.Scene,
    private readonly state: PlayerState,
  ) {
    const x = 24;
    const y = 70;
    this.container = scene.add.container(x, y).setVisible(false).setDepth(30);

    const g = scene.add.graphics();
    g.fillStyle(COLOR.panelEdge, 0.96);
    g.fillRoundedRect(-4, -4, WIDTH + 8, HEIGHT + 8, 12);
    g.fillStyle(COLOR.window, 0.98);
    g.fillRoundedRect(0, 0, WIDTH, HEIGHT, 10);
    this.container.add(g);

    const title = scene.add.text(PAD, 10, '퀘스트', {
      fontFamily: UI_FONT,
      fontSize: '16px',
      color: TEXT_COLOR.dark,
    });
    const close = scene.add
      .text(WIDTH - PAD, 12, '✕', {
        fontFamily: UI_MONO,
        fontSize: '14px',
        color: TEXT_COLOR.dark,
      })
      .setOrigin(1, 0)
      .setInteractive({ useHandCursor: true });
    close.on('pointerdown', () => this.close());
    this.body = scene.add.text(PAD, 40, '', {
      fontFamily: UI_FONT,
      fontSize: '13px',
      color: TEXT_COLOR.dark,
      wordWrap: { width: WIDTH - PAD * 2, useAdvancedWrap: true },
    });
    this.container.add([title, close, this.body]);

    this.state.events.on(EV.questChanged, this.refresh, this);
    scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
      this.state.events.off(EV.questChanged, this.refresh, this);
    });
  }

  toggle(): boolean {
    this.container.setVisible(!this.container.visible);
    if (this.container.visible) this.refresh();
    return this.container.visible;
  }

  close(): void {
    this.container.setVisible(false);
  }

  get visible(): boolean {
    return this.container.visible;
  }

  private refresh = (): void => {
    const lines: string[] = [];
    for (const def of Object.values(QUESTS)) {
      const phase = questPhase(def.id, this.state.quests, this.state.inventory);
      if (phase === 'locked' || phase === 'offer') continue;
      const progress = questProgress(def, this.state.quests[def.id], this.state.inventory);
      const tag = phase === 'done' ? '완료' : phase === 'ready' ? '보고' : '진행';
      lines.push(`· ${def.name}  [${tag}]  ${Math.min(progress, def.count)}/${def.count}`);
    }
    this.body.setText(lines.length ? lines.join('\n') : '진행 중인 퀘스트가 없습니다.\n마을에서 NPC 와 대화하세요.');
  };
}
